import { FunctionComponent } from 'react'

import styled from 'styled-components'

import { LinkCarouselTile } from '@widgets/LinkCarousel'
import FreeRatioImage from '@components/FreeRatioImage'
import { ImageConstraints } from '@components/FreeRatioImage/types'

const LOGO_CONSTRAINTS = {
  desktop: {
    width: 48,
    height: 48,
  },
  tablet: {
    width: 48,
    height: 48,
  },
  mobile: {
    width: 48,
    height: 48,
  },
  mobileSmall: {
    width: 48,
    height: 48,
  },
} as const satisfies ImageConstraints

export type LinkCarouselLogoProps = Pick<
  LinkCarouselTile,
  'image' | 'imageDark'
>

const StyledLinkCarouselLogo = styled.div`
  align-items: center;
  background-color: transparent;
  display: flex;
  justify-content: center;
  height: 48px;
`

const LinkCarouselLogo: FunctionComponent<LinkCarouselLogoProps> = ({
  image,
  imageDark,
}) => {
  const { alt, crops, height, src, width } = image || {}

  return (
    <StyledLinkCarouselLogo>
      {!!image && (
        <FreeRatioImage
          alt={alt}
          constraints={LOGO_CONSTRAINTS}
          crops={crops ?? {}}
          originalDimensions={{ width, height }}
          src={src}
          {...(imageDark?.src
            ? {
                darkModeImage: {
                  src: imageDark.src,
                  originalDimensions: {
                    width: imageDark.width,
                    height: imageDark.height,
                  },
                  crops: imageDark.crops ?? {},
                },
              }
            : {})}
        />
      )}
    </StyledLinkCarouselLogo>
  )
}

export default LinkCarouselLogo
